import { render, staticRenderFns } from "./progress-spinner.vue?vue&type=template&id=22e0895a"
import script from "./progress-spinner.vue?vue&type=script&lang=js"
export * from "./progress-spinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports